import React, { useState, useEffect } from 'react';
import temple1 from '../assets/temple1.jpg';
import temple2 from '../assets/temple2.jpg';
import temple3 from '../assets/temple3.jpg';
import temple4 from '../assets/temple4.jpg';
import temple5 from '../assets/temple5.jpg';

function About() {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const royalBlue = '#002366';
  const background = '#f8faff';

  const imageAlts = [
    'Traditional South Indian temple designed by Kalyanasundaram Sthapathi',
    'Intricate temple sculpture and carvings in ancient style',
    'Gopuram of a temple built following Agama Shastra',
    'Stone mandapam architecture by experienced sthapathis',
    'Completed temple structure with authentic Vastu design',
  ];

  return (
    <section
      style={{
        minHeight: '100vh',
        width: '100vw',
        padding: isMobile ? '20px' : '40px',
        fontFamily: 'Times New Roman, serif',
        backgroundColor: background,
        color: '#2c2c2c',
        boxSizing: 'border-box',
        overflowY: 'auto',
      }}
    >
      <h2
        style={{
          textAlign: 'center',
          marginBottom: '30px',
          fontSize: isMobile ? '1.4rem' : '2rem',
          color: royalBlue,
          fontWeight: 'bold',
        }}
      >
        ABOUT US
      </h2>

      <div
        style={{
          width: '100%',
          fontSize: isMobile ? '1rem' : '1.1rem',
          lineHeight: '1.8',
          textAlign: 'justify',
        }}
      >
        <p style={{ marginBottom: '20px' }}>
          At <strong>Kalyanasundaram Sthapathi Pvt Ltd</strong>, we specialize in comprehensive temple architecture,
          contracting, and turnkey project execution. Our mission is to bring to life traditional South Indian temples
          and heritage structures with the highest standards of authenticity and craftsmanship.
        </p>

        <p style={{ marginBottom: '20px' }}>
          Our contracting services include the construction of temples, mandapams, gopurams, manimandapams,
          educational institutions, and memorial halls. We offer end-to-end project execution while upholding
          tradition, precision, and devotion.
        </p>

        <p>
          Backed by a network of sthapathis, sculptors, and engineers, our turnkey solutions cover architectural design,
          construction, idol placement, and restoration—preserving spiritual integrity while meeting modern standards.
          With decades of experience and deep cultural insight, we create timeless temples that inspire generations.
        </p>
      </div>

      {/* Image Gallery */}
      <div
        style={{
          marginTop: '40px',
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'center',
          gap: '20px',
        }}
      >
        {[temple1, temple2, temple3, temple4, temple5].map((img, index) => (
          <img
            key={index}
            src={img}
            alt={imageAlts[index]}
            style={{
              width: '100%',
              maxWidth: '220px',
              height: '200px',
              objectFit: 'cover',
              borderRadius: '8px',
            }}
          />
        ))}
      </div>
    </section>
  );
}

export default About;












